export const apiUrl = process.env.REACT_APP_BACKEND_URL;
export const finagApiUrl = process.env.REACT_APP_FINAG_URL;
